
 
export const FETCH_IMAGE_TYPES_REQUEST = 'imageTypes/FETCH_IMAGE_TYPES_REQUEST';
export const FETCH_IMAGE_TYPES_SUCCESS = 'imageTypes/FETCH_IMAGE_TYPES_SUCCESS';
export const FETCH_IMAGE_TYPES_FAILURE = 'imageTypes/FETCH_IMAGE_TYPES_FAILURE';

 
export const FETCH_IMAGE_TYPE_REQUEST = 'imageTypes/FETCH_IMAGE_TYPE_REQUEST';
export const FETCH_IMAGE_TYPE_SUCCESS = 'imageTypes/FETCH_IMAGE_TYPE_SUCCESS';
export const FETCH_IMAGE_TYPE_FAILURE = 'imageTypes/FETCH_IMAGE_TYPE_FAILURE';

 
export const DELETE_IMAGE_TYPE_REQUEST = 'imageTypes/DELETE_IMAGE_TYPE_REQUEST';
export const DELETE_IMAGE_TYPE_SUCCESS = 'imageTypes/DELETE_IMAGE_TYPE_SUCCESS';
export const DELETE_IMAGE_TYPE_FAILURE = 'imageTypes/DELETE_IMAGE_TYPE_FAILURE';

 
export const CREATE_IMAGE_TYPE_REQUEST = 'imageTypes/CREATE_IMAGE_TYPE_REQUEST';
export const CREATE_IMAGE_TYPE_SUCCESS = 'imageTypes/CREATE_IMAGE_TYPE_SUCCESS';
export const CREATE_IMAGE_TYPE_FAILURE = 'imageTypes/CREATE_IMAGE_TYPE_FAILURE';

 
export const UPDATE_IMAGE_TYPE_REQUEST = 'imageTypes/UPDATE_IMAGE_TYPE_REQUEST';
export const UPDATE_IMAGE_TYPE_SUCCESS = 'imageTypes/UPDATE_IMAGE_TYPE_SUCCESS';
export const UPDATE_IMAGE_TYPE_FAILURE = 'imageTypes/UPDATE_IMAGE_TYPE_FAILURE';


export const UPDATE_FIELD = 'imageTypes/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'imageTypes/SET_DEFAULT_DATA';
